import { main } from './schedule/main.es6';

document.addEventListener('DOMContentLoaded', main);
